<template>
  <b-field :horizontal="horizontal" label="Vetted Note">
    <b-select v-model="value" @input="onInput" expanded :multiple="multiple" :disabled="loading" :loading="loading">
      <option value="" v-if="!multiple">
        <slot name="defaultOptionLabel">Please Select</slot>
      </option>
      <option v-for="option in options" :value="option.id" :key="option.id">
        {{ option.shortText }} - {{ option.longText }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { VettedStatementService } from "@/services/vettedStatement.service.js";

export default {
  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    organization: {
      type: Object
    }
  },
  data: () => ({
    value: "",
    options: [],
    loading: false
  }),
  created() {
    this.fetchOptions();
    this.reset();
  },
  computed: {
    selected() {
      return this.options.find(option => option.id === this.value);
    },
    user() {
      return this.$store.state.Auth.user;
    }
  },
  methods: {
    fetchOptions() {
      this.loading = true;

      VettedStatementService.all({
        include: "vettedOrderActivityRelationships",
        orderBy: "short_text",
        firm_id: this.organization ? this.organization.id : this.user.firmId
      }).then(
        response => {
          this.options = JsonDenormalizer.denormalize(response);
          this.loading = false;
        },
        err => {
          this.loading = false;
        }
      );
    },
    onInput() {
      this.$emit("input", this.selected);
    },
    reset() {
      this.value = this.multiple ? [] : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/partials/selectVettedStatement.vue